
import React, { createContext, useContext, useState, ReactNode } from "react";

interface PlanSelectDialogContextProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  openDialog: () => void;
  closeDialog: () => void;
}

const PlanSelectDialogContext = createContext<PlanSelectDialogContextProps | undefined>(undefined);

export function PlanSelectDialogProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  return (
    <PlanSelectDialogContext.Provider value={{ open, setOpen, openDialog, closeDialog }}>
      {children}
    </PlanSelectDialogContext.Provider>
  );
}

export function usePlanSelectDialog() {
  const ctx = useContext(PlanSelectDialogContext);
  if (!ctx) throw new Error("usePlanSelectDialog must be used within a PlanSelectDialogProvider");
  return ctx;
}
